(function ($) {
    var openedBy = "closed";

    this.init = function () {
        this.OnlineBanking();
    };


    /****************************************************************
     Online Banking BANNER
    ****************************************************************/
    this.OnlineBanking = function () {


        $("#olb_open_desktop").on("click", DesktopOpen);
        $(".mainnav-content-right-olb").on("mouseenter", DesktopOpen);
//        $(".mainnav-content-right-olb").on("mouseleave", DesktopCloseHover);
        $("#olb_close_desktop").on("click", CloseOlb);
        $("#olb_open_mobile").on("click", MobileOpen);
        $("#olb_close_mobile").on("click", CloseOlb);

        // on resize close the stuff
        $(window).on("resize", ResizeOlb);

        $("#OLBSkip").on("click", function () {
            // if we're in desktop - shoot us over to the desktop button, else bring us to the mobile one.
            $("#olb_open_desktop:visible,#olb_open_mobile:visible").first().focus();

        });
    }
    function ResizeOlb() {
        if (window.innerWidth > 991) {
            CloseOlb();
        }
    }
    function DesktopOpenHover() {
        if (openedBy === "closed") {
            CloseOlb();
            // set the top and the left attributes to this button
            $("#Olb").css("top", $(".mainnav-content-right-olb").offset().top + $(".mainnav-content-right-olb").outerHeight()).css("left", $(".mainnav-content-right-olb").offset().left - $("#Olb").outerWidth() + $(".mainnav-content-right-olb").outerWidth());
            $("#Olb").show();
            $("#olb_open_desktop").hide().attr("aria-expanded", true);
            $("#olb_close_desktop").show().attr("aria-expanded", true).focus();
            openedBy = "hover";
        }
    }
    function DesktopCloseHover() {
        if (openedBy === "hover") {
            CloseOlb();
        }
    }

    function DesktopOpen() {
        CloseOlb();
         // set the top and the left attributes to this button
        $("#Olb").css("top", $(".mainnav-content-right-olb").offset().top + $(".mainnav-content-right-olb").outerHeight()).css("left", $(".mainnav-content-right-olb").offset().left - $("#Olb").outerWidth() + $(".mainnav-content-right-olb").outerWidth());
        $("#Olb").show();
        $("#olb_open_desktop").hide().attr("aria-expanded",true);
        $("#olb_close_desktop").show().attr("aria-expanded", true).focus();
        openedBy = "click";
    }
    function MobileOpen() {
        CloseOlb();
        $("#Olb").css("top", 0).css("left", 0);
        $("#Olb").show();
        $("#olb_open_mobile").hide().attr("aria-expanded",true);
        $("#olb_close_mobile").show().attr("aria-expanded", true).focus();
    }
    function CloseOlb() {
        // Close DesktopOlb
        $("#Olb").hide();
        // Make sure DesktopShow Button is set to login
        $("#olb_open_desktop").show().attr("aria-expanded", false);
        $("#olb_close_desktop").hide().attr("aria-expanded",false);
        openedBy = "closed";
        
        // Close Mobile Olb
        $("#Olb").hide();
        // Hide Mobile Close Button and show the login button
        $("#olb_open_mobile").show().attr("aria-expanded", false);
        $("#olb_close_mobile").hide().attr("aria-expanded", false);
    }
    this.init();

})(jQuery);